import type { OrderInfo } from '@eliadmin/core/src/api/claims/claims-api';
import type { CustomerOrder } from '@eliadmin/core/src/api/customers/customers-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const createBackgroundColor = (hexColor: string | null, magnitude: number): string | undefined => {
  if (!hexColor || !magnitude) {
    return undefined;
  }
  // Remove the '#' if it's present
  hexColor = hexColor.replace('#', '');

  if (hexColor.length === 6 || hexColor.length === 8) {
    const hasAlpha = hexColor.length === 8;
    const decimalColor = parseInt(hexColor.substring(0, 6), 16); // Parse the RGB part of the hex

    let r = (decimalColor >> 16) + magnitude;
    r = Math.min(255, Math.max(0, r)); // Ensure r is between 0 and 255

    let g = ((decimalColor >> 8) & 0x00ff) + magnitude;
    g = Math.min(255, Math.max(0, g)); // Ensure g is between 0 and 255

    let b = (decimalColor & 0x0000ff) + magnitude;
    b = Math.min(255, Math.max(0, b)); // Ensure b is between 0 and 255

    const newHex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0'); // Convert to hex and pad

    if (hasAlpha) {
      const alpha = hexColor.substring(6, 8); // Extract the alpha part (last 2 characters)
      return `#${newHex}${alpha}`; // Return the new color with alpha included
    } else {
      return `#${newHex}`; // Return the new color without alpha
    }
  } else {
    return `#${hexColor}`; // Return the original hex if it's not a valid 6/8-length hex string
  }
};

export type ProfileOrderStatusProps = {
  order: CustomerOrder | OrderInfo;
};
export function ProfileOrderStatus(props: ProfileOrderStatusProps) {
  const backgroundColor = props.order.status?.color ?? '#000';
  const color = props.order.status?.color_text ?? '#000';

  const { t } = useTranslations();

  return (
    <div
      className="flex h-[21px] items-center justify-center whitespace-nowrap rounded-full px-2 text-center text-xs font-semibold text-white sm:h-[23px]"
      style={{
        color: color || undefined,
        backgroundColor: backgroundColor
          ? backgroundColor
          : color
            ? createBackgroundColor(color, 175)
            : undefined,
      }}
    >
      {props.order.status?.name ?? t('text1102')}
    </div>
  );
}
